// extracted by mini-css-extract-plugin
export default {"form":"ProductImageForm_form__zVWBP","image":"ProductImageForm_image__+-FK+","picture":"ProductImageForm_picture__7dJoY"};